import script from "./IbhFastbookingWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./IbhFastbookingWrapper.vue?vue&type=script&setup=true&lang=js"

import "./IbhFastbookingWrapper.vue?vue&type=style&index=0&id=774d3a58&lang=scss"

const __exports__ = script;

export default __exports__